/**
 * Prazo do pedido = maior fabricação do carrinho + frete (Sedex/PAC no checkout).
 */
(function () {
  'use strict';

  var SOURCE = 'andrade-prazo';
  var ATTR = 'Prazo do pedido';
  var ATTR_DAYS = '_andrade_prazo_max_dias';
  var lock = Promise.resolve();
  var i18n = {
    production: 'Este pedido segue o maior prazo: {{ days }} dias úteis de fabricação, mais o frete até o CEP.',
    ready: 'Este pedido é pronta entrega: envio em até 48h úteis, mais o frete até o CEP.',
    attribute: 'Fabricação até {{ days }} dias úteis + o prazo do frete (Sedex/PAC).',
    attributeReady: 'Pronta entrega (até 48h úteis) + o prazo do frete (Sedex/PAC).',
  };

  var node = document.getElementById('AndradePrazoPedidoI18n');
  if (node) {
    try {
      var parsed = JSON.parse(node.textContent || '{}');
      Object.keys(parsed).forEach(function (key) {
        if (parsed[key]) i18n[key] = parsed[key];
      });
    } catch (e) {}
  }

  function fill(tpl, days) {
    return String(tpl || '').split('{{ days }}').join(String(days));
  }

  function jsonFetch(url, options) {
    return fetch(
      url,
      Object.assign({ credentials: 'same-origin', headers: { Accept: 'application/json' } }, options || {})
    ).then(function (res) {
      return res.json().then(
        function (body) {
          return { ok: res.ok, body: body };
        },
        function () {
          return { ok: res.ok, body: null };
        }
      );
    });
  }

  function itemDays(item) {
    if (!item) return 0;
    var props = item.properties || {};
    if (String(props._andrade_gift || '') === '1') return 0;
    var n = Number(props._andrade_prazo_dias);
    if (n > 0) return n;
    var blob = String(props.Prazo || props['Lead time'] || '');
    var match = blob.match(/(\d+)/);
    if (match) return Number(match[1]);
    return 15;
  }

  function maxDays(cart) {
    var max = 0;
    var paid = false;
    ((cart && cart.items) || []).forEach(function (item) {
      var days = itemDays(item);
      if (!days) return;
      paid = true;
      if (days > max) max = days;
    });
    if (!paid) return 0;
    return max || 15;
  }

  function attributeFor(days) {
    if (days <= 2) return i18n.attributeReady;
    return fill(i18n.attribute, days);
  }

  function paint() {
    document.querySelectorAll('[data-andrade-prazo-pedido]').forEach(function (el) {
      el.hidden = true;
      el.textContent = '';
    });
  }

  function ensurePrazo() {
    lock = lock.catch(function () {}).then(function () {
      return jsonFetch('/cart.js').then(function (res) {
        var cart = res.body;
        if (!cart) return null;
        var days = maxDays(cart);
        paint();
        if (!days) return cart;
        var attrs = cart.attributes || {};
        var nextLabel = attributeFor(days);
        if (String(attrs[ATTR] || '') === nextLabel && String(attrs[ATTR_DAYS] || '') === String(days)) {
          return cart;
        }
        var attributes = {};
        Object.keys(attrs).forEach(function (key) {
          attributes[key] = attrs[key];
        });
        attributes[ATTR] = nextLabel;
        attributes[ATTR_DAYS] = String(days);
        return jsonFetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: attributes }),
        }).then(function (updated) {
          var next = updated.body || cart;
          document.dispatchEvent(
            new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: next,
                sourceId: SOURCE,
                data: { source: SOURCE, itemCount: next && next.item_count },
              },
            })
          );
          return next;
        });
      });
    });
    return lock;
  }

  document.addEventListener('cart:update', function (event) {
    var source = event && event.detail && event.detail.data && event.detail.data.source;
    if (source === SOURCE) return;
    ensurePrazo();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensurePrazo);
  } else {
    ensurePrazo();
  }

  function wrapCheckout() {
    if (!window.AndradeCheckout || typeof window.AndradeCheckout.go !== 'function') return;
    if (window.AndradeCheckout.__prazoWrapped) return;
    window.AndradeCheckout.__prazoWrapped = true;
    var prev = window.AndradeCheckout.go;
    window.AndradeCheckout.go = function () {
      return ensurePrazo().then(function () {
        return prev();
      });
    };
  }

  wrapCheckout();
  document.addEventListener('DOMContentLoaded', wrapCheckout);
})();
